import { useRef, useState } from 'react'
import { Image, Loader2 } from 'lucide-react'
import { mediaService } from '../../services/mediaService'
import { useAuth } from '../../contexts/AuthContext'

interface MediaUploadButtonProps {
    onUploadComplete: (url: string) => void
    disabled?: boolean
    className?: string
}

export function MediaUploadButton({ onUploadComplete, disabled, className }: MediaUploadButtonProps) {
    const { sk, loginMethod } = useAuth()
    const [isUploading, setIsUploading] = useState(false)
    const fileInputRef = useRef<HTMLInputElement>(null)

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]
        if (!file || !loginMethod) return

        // Reset input to allow selecting same file again
        e.target.value = ''

        // 10MB limit
        if (file.size > 10 * 1024 * 1024) {
            alert('Dosya boyutu çok büyük (Maksimum 10MB).')
            return
        }

        setIsUploading(true)
        try {
            const url = await mediaService.uploadFile(file, loginMethod, sk || undefined)
            onUploadComplete(url)
        } catch (error: any) {
            console.error('Upload failed:', error)
            alert(error.message || 'Resim yüklenemedi.')
        } finally {
            setIsUploading(false)
        }
    }

    if (!sk && !window.nostr) return null; // Only show if logged in

    return (
        <>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept="image/*"
                className="hidden"
            />
            <button
                type="button"
                onClick={() => fileInputRef.current?.click()}
                disabled={disabled || isUploading}
                className={`flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${className || 'text-gray-500 hover:text-mavi-600 hover:bg-mavi-50 dark:text-gray-400 dark:hover:text-mavi-400 dark:hover:bg-mavi-900/20'}`}
                title="Resim yükle"
            >
                {isUploading ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                    <Image className="w-4 h-4" />
                )}
                <span className="hidden sm:inline">Görsel Ekle</span>
            </button>
        </>
    )
}
